import CallMadeRoundedIcon from '@mui/icons-material/CallMadeRounded';
import { Box, Grid, IconButton, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { getRandomStr } from '../../../../../helpers';
import { convertDate_MDY } from '../../../../../helpers/time';
import usePagination from './FilingPagination';
// import Link from 'next/link';
import { downloadCSV, useFetchTabData, } from '../../../../../utils/helpers';
// import { usePagination } from '@mui/lab';
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import * as send from '../../../../../../lib/analytics/send';
import getLatestFilings from '../../../../../../lib/stock/_getLatestFilings';
import { needPremium } from '../../../../../needPremium';

const SECItem = styled(Paper)(({ theme }) => ({
  fontWeight: 600,
  borderRadius: '4px',
  backgroundColor: theme.palette?.mode === 'dark' ? 'rgb(10, 25, 41) !important' : '#fff !important',
  color: `${theme.palette?.text?.secondary} !important`,
  // boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  // boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(255 255 255 / 20%), 0 2px 3px rgb(255 255 255 / 10%) !important',
  // border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : '1px solid #eae9ee !important',
  borderRadius: '7px',
  '& .Item-Head': {
    background: '#fbfbfc !important',
    borderBottom: '1px solid #eae9ee',
    marginBottom: '0 !important',
    padding: `${theme.spacing(1, 1)}`,
    borderRadius: '7px 7px 0 0 !important',
    '& a': {
      textDecoration: 'none',
    },
    '& .option-title': {
      fontWeight: '600 !important',
      color: '#13113c  !important',
      fontSize: '.875rem  !important',
    }
  },
  '& .Item-Body': {
    padding: `${theme.spacing(1)} !important`,
  }
}));

const Filings = ({ info, showTicker, premiumOptions = true, description, isPremium, showPricingBanner, dataEventFrom }) => {

  // let filing_settings = tabData && tabData.length > 0 ? tabData.find(d => d.section_code === "SEC_Filings") : null
  // filing_settings = filing_settings && filing_settings.settings ? parseTabData(filing_settings).settings : {}
  let { data: filing_settings, loading } = useFetchTabData(info?.ticker, "SEC_Filings", "NEW_SUM_OD", "SECF")
  const { limit, report, reportbg, baseSECLink } = filing_settings?.settings || {}

  let [page, setPage] = useState(1);
  const [latestFilings, setLatestFilings] = useState([]);
  const ROWS_PER_PAGE = limit || 10;

  useEffect(() => {
    setPage(1)
  }, [info?.companyName]);

  const count = Math.ceil(latestFilings?.length / ROWS_PER_PAGE);
  const _FILINGS = usePagination(latestFilings, ROWS_PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _FILINGS.jump(p);
  };

  // const emptyRows = ROWS_PER_PAGE - Math.min(ROWS_PER_PAGE, latestFilings.length - (page * ROWS_PER_PAGE));
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * ROWS_PER_PAGE - latestFilings?.length) : 0;

  // useEffect(() => typeof window !== "undefined" && window?.location?.hash?.includes("#") && scrollIntoView())

  const headerCols = [{ name: "Date Filed", field: "dateFiled", }, { name: "Ticker", field: "ticker", }, { name: "Form Type", field: "formType", }, { name: "Document", field: "docHeading", }, { name: "Link to Doc", field: "filename", },]
  const useformatDate = true;
  const handleDownload = (e) => {
    if (isPremium) {
      downloadCSV(latestFilings, headerCols, `Recent SEC Filings of ${info?.companyName} (${info?.ticker})`, useformatDate);
      send.uevent(e)
    } else {
      showPricingBanner(e, "filing");
    }
  };

  const gotopage = (event) => {
    showPricingBanner(event, "filing");
    event.preventDefault()
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getLatestFilings(info?.ticker);
        setLatestFilings(result?.getLatestFilings || []);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLatestFilings([]);
      }
    };

    fetchData();
  }, [info?.ticker]);

  if (loading) {
    return <Grid size={{ xs: 12, sm: 12, md: 12 }}><Skeleton variant="rounded" width={'100%'} height={470} /></Grid>
  }

  return (
    <>
      {latestFilings && latestFilings.length > 0 &&
        <Grid size={{ md: 6, xs: 12 }}>
          <section id="filings">
            <SECItem className="filings" elevation={0} variant="outlined" style={{ borderRadius: '7px', borderColor: '#eae9ee', }}>
              {/* {info?.companyName &&
            <Box
              className='Item-Head'
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                mb: 0.5,
                px: 0.5,
              }}
            >
              <Typography component="h4" className="option-title" sx={{ mr: 'auto' }} >
                Recent SEC Filings of {info?.companyName}
              </Typography>
            </Box>} */}
              <Box
                // className="Item-Head"
                sx={{
                  py: description ? '2px !important' : '6px',
                  display: 'flex', background: '#fbfbfc',
                  alignItems: 'center', flexWrap: 'wrap',
                  borderRadius: '7px 7px 0 0 !important',
                  borderBottom: '0 !important',
                  px: description ? '8px !important' : '12px',
                  '& a': { textDecoration: 'none', fontSize: '.875rem', textTransform: 'capitalize', background: '#fbfbfc', fontWeight: 500 },
                  '& a:hover': {
                    // background: '#e6e7eb',
                    background: '#f0f1f4',
                    border: '1px solid #dbdce4',
                    // color: 'text.link'
                  },
                }}
              >
                <Typography component="h4" className="option-title"
                  sx={{
                    pr: 0.5, bgcolor: '#fbfbfc !important',
                    mr: 'auto', fontWeight: '600 !important',
                    color: '#13113c  !important', // mx: 1, mt: 1.5,
                    fontSize: '.875rem  !important',
                  }} >
                  {/* <span id="company-filings"></span> */}
                  {/* <Link href="/stock/AAPL#company-filings" scroll={false}> */}
                  {`Recent SEC Filings ${info && info.companyName ? 'of ' + info?.companyName : ''}`}
                  {/* </Link> */}
                </Typography>
                {premiumOptions &&
                  <IconButton variant="outlined" size="small"
                    data-event-name="download-csv" data-event-category="stock" data-event-label="sec-filings"
                    // startIcon={<FileDownloadOutlinedIcon sx={{ fontSize: '.8rem !important' }} />}
                    sx={{
                      // px: 1, py: 0.5, lineHeight: 1,
                      color: '#565b75', background: '#fbfbfc', border: '1px solid #dbdce4',
                      // '&:hover': {
                      //   background: 'transparent !important',
                      // }, mt: 1,
                      mr: 1.2, ml: 'auto'
                    }}
                    onClick={handleDownload}
                  >
                    <FileDownloadOutlinedIcon sx={{ fontSize: '1.2rem !important' }} />
                  </IconButton>}
                {premiumOptions &&
                  <IconButton variant="outlined" size="small"
                    sx={{
                      // px: 1, py: 0.5, lineHeight: 1,
                      color: '#565b75', background: '#fbfbfc', border: '1px solid #dbdce4',
                      // mt: 1,
                    }}
                    target="_blank" rel="noopener"
                    href={`${baseSECLink}${info?.ticker}`}
                    onClick={(event) => { !isPremium && gotopage(event); send.uevent(event) }}
                    data-event-name={`Recent SEC Filings ${info && info.companyName ? 'of ' + info?.companyName : ''}`}
                    data-event-category="stock"
                    data-event-label="View All Filings"
                  >
                    <ArrowOutwardRoundedIcon sx={{ fontSize: '1.2rem !important' }} />
                  </IconButton>}
              </Box>
              {description && <Typography variant="body2" component="div" sx={{ fontSize: '.75rem !important', px: 1.7, pb: 2, background: '#fbfbfc' }} color="text.secondary">{description}</Typography>}
              <TableContainer
                sx={{
                  '.viewDoc': { visibility: 'hidden' }, '& tr:hover .viewDoc': { visibility: 'visible' },
                  '& th': {
                    fontSize: '.875rem !important', p: '6px 12px', color: showTicker ? 'text.secondary' : 'text.descriptoin', background: '#fbfbfc', fontWeight: showTicker ? 500 : 600
                  },
                  '& th, td': {
                    borderColor: '#eae9ee',
                  },
                }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      {showTicker && <TableCell> Ticker </TableCell>}
                      <TableCell> Date </TableCell>
                      <TableCell> Form </TableCell>
                      <TableCell> Document </TableCell>
                      <TableCell> {" "}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className="fv-tb-body">
                    {latestFilings && latestFilings.length > 0 &&
                      // latestFilings
                      // .slice(0, limit)
                      _FILINGS.currentData().map(d => {
                        return (
                          <TableRow
                            itemScope itemType="https://schema.org/Filing"
                            onClick={(e) => {
                              window.open(`${d?.filename}`, '_blank', 'noreferrer', 'nofollow');
                              send.uevent(e)
                            }}
                            className={`text-center tr`} key={getRandomStr(3)} hover
                            selected={d?.docHeading === report}
                            sx={{
                              // background: d?.docHeading === report ? (reportbg ?? '#e4eaf08a') : '',
                              cursor: 'pointer'
                            }}>
                            {showTicker &&
                              <TableCell sx={{ p: '6px 12px', color: 'text.link' }} className=" ">
                                <Typography variant='caption' sx={{ fontWeight: 600, fontSize: '.875rem' }}>{d?.ticker}</Typography>
                              </TableCell>}
                            <TableCell
                              data-event-name={`Recent SEC Filings ${info && info.companyName ? 'of ' + info?.companyName : ''}`}
                              data-event-category={`stock-${dataEventFrom}`} data-event-label={d?.ticker + " " + d?.filename + " " + d?.docHeading}
                              itemProp="dateFiled" sx={{ p: '6px 12px', color: 'text.description' }} className=" "
                            >
                              <Typography variant='caption' sx={{ fontWeight: d?.docHeading === 'Quarterly Report' ? 600 : 500, fontSize: '.875rem', whiteSpace: "nowrap" }}>{convertDate_MDY(d?.dateFiled)}</Typography>
                            </TableCell>
                            <TableCell
                              data-event-name={`Recent SEC Filings ${info && info.companyName ? 'of ' + info?.companyName : ''}`}
                              data-event-category={`stock-${dataEventFrom}`} data-event-label={d?.ticker + " " + d?.filename + " " + d?.docHeading}
                              itemProp="documentType" sx={{ p: '6px 12px', whiteSpace: "nowrap", }} className=" "
                            >
                              <Typography component="div" variant='caption' sx={{ fontSize: '.875rem', fontWeight: 600 }}> {d?.formType}</Typography>
                            </TableCell>
                            <TableCell
                              data-event-name={`Recent SEC Filings ${info && info.companyName ? 'of ' + info?.companyName : ''}`}
                              data-event-category={`stock-${dataEventFrom}`} data-event-label={d?.ticker + " " + d?.filename + " " + d?.docHeading}
                              itemProp="documentType" className="qtr-rep" sx={{ p: '6px 12px', '& a': { color: '#555', textDecoration: 'none' }, '& a:hover': { textDecoration: 'underline' }, whiteSpace: "nowrap" }}
                            >
                              {/* <a target="_blank" rel="noreferrer nofollow" href={`${d?.filename}`}> */}
                              <Typography variant='caption' sx={{ fontSize: '.875rem', fontWeight: d?.docHeading === 'Quarterly Report' ? 600 : 500, color: '#434166' }}>{d?.docHeading}</Typography>
                              {/* </a> */}
                            </TableCell>
                            {/* <TableCell sx={{ p: '6px' }} className=" "><OpenInNewRoundedIcon className="viewDoc" sx={{ fontSize: '.8rem' }} /></TableCell> */}
                            <TableCell sx={{ p: '6px' }} className=" "><CallMadeRoundedIcon className="" sx={{ fontSize: '.875rem', color: '#434166' }} /></TableCell>
                          </TableRow>
                        )
                      })}
                    {/* {emptyRows > 0 && latestFilings.length > 0 && count === page && (
                    <TableRow style={{ height: 16.54 * emptyRows }}>
                      <TableCell colSpan={4} />
                    </TableRow>
                  )} */}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', background: '#fbfbfc', }}> */}
              {/* <Typography variant="caption" sx={{ mx: 2 }}>{emptyRows}</Typography> */}
              <Pagination
                sx={{
                  borderRadius: '0 0 7px 7px !important',
                  width: "100%",
                  p: 1.5, textAlign: 'center', background: '#fbfbfc',
                  '& .MuiPagination-ul': { justifyContent: 'end' },
                  '& .MuiPaginationItem-root': { m: '0 8px' }
                }}
                count={count}
                size="small"
                page={page}
                color="primary"
                siblingCount={0}
                // variant="outlined"
                // showFirstButton
                // showLastButton
                // hidePrevButton
                // hideNextButton
                onChange={handleChange}
              />
              {/* </Box> */}
            </SECItem>
          </section>
        </Grid>}
    </>
  )
}

export default React.memo(needPremium(Filings))
